import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { APIPATH } from '../App';


function Logout() {
    const navigate = useNavigate();

    useEffect(() => {
        const doLogout = async () => {
            try {
                await fetch(`${APIPATH}/Auth/logout`, {
                    method: "POST",
                    credentials: "include", 
                });
            } catch (err) {
                console.error("Logout error:", err);
            }

            navigate("/login", { replace: true });
        };

        doLogout();
    }, [navigate]);

    return (
        <div className="main container py-4 mb-6">
            <h2>Logging out…</h2>
        </div>
    );
}

export default Logout;
